import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';

interface Blog {
  id: string;
  blogname: string;
  author: string;
  date: string;
  status: string;
  blogcontent: string;
  eventcode?: string;
}

function BlogDetail() {
  const [events, setEvents] = useState<any[]>([]);
  const [blog, setBlog] = useState<Blog | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
    const queryParams = new URLSearchParams(window.location.search);
    const blogId = queryParams.get("blogid");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        setError(null);
        console.log('Fetching blog with ID:', blogId);  
        // Fetch blog data from API
        const response = await AxiosInstance.get(`/api/getblogs?blogid=${blogId ? encodeURIComponent(blogId) : ''}`);
        
        if (response.data.result === 'Success' && response.data.data) {
          setBlog(response.data.data);
        } else {
          setError('Blog not found.');
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching blog:', error);
        setError('Failed to load blog. Please try again later.');
        setLoading(false);
      }
    };

    if (blogId) {
      fetchBlog();
    }
  }, [blogId]);

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="antialiased light-vz circle-v ">
        <Header events={events} />
        <br></br>
        <h1 className='spacer-section'></h1>
        
        <div className="loading-spinner">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        
        <MainWebFooter />
        <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
      </div>
    );
  }

  if (error) {
    return (
      <div className="antialiased light-vz circle-v ">
        <Header events={events} />
        <br></br>
        <h1 className='spacer-section'></h1>
        
        <div className="error-message">
          <i className="fa fa-exclamation-triangle"></i> {error}
        </div>
        
        <MainWebFooter />
        <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="antialiased light-vz circle-v ">
        <Header events={events} />
        <br></br>
        <h1 className='spacer-section'></h1>
        
        <div className="no-blogs">
          <p>Blog not found.</p>
        </div>
        
        <MainWebFooter />
        <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
      </div>
    );
  }

  return (
    <>
      <style>
        {`
          .blog-detail-container {
            max-width: 100%;
            margin: 0 ;
            padding: 20px;
          }
          
          .blog-detail-meta {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            margin-bottom: 20px;
            font-size: 16px;
            color: #666;
          }
          
          .blog-detail-author {
            font-weight: 600;
            color: #007bff;
          }
          
          .blog-detail-date {
            color: #888;
          }
          
          .blog-detail-event {
            background: #e3f2fd;
            color: #1976d2;
            padding: 4px 12px;
            border-radius: 20px;
            font-size: 14px;
          }
          
          .blog-detail-title {
            font-size: 36px;
            font-weight: 700;
            color: #ffffff;
            margin-bottom: 30px;
            line-height: 1.2;
          }
          
          .blog-detail-content {
            font-size: 18px;
            line-height: 1.8;
            color: #ffffff;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-word;
            overflow-wrap: anywhere;
            hyphens: auto;
            box-sizing: border-box;
            max-width: 100%;
            width: 100%;
          }
          
          .blog-detail-content p {
            margin-bottom: 20px;
            display: block;
            margin-top: 0;
            margin-bottom: 20px;
          }
          
          .blog-detail-content h2,
          .blog-detail-content h3,
          .blog-detail-content h4 {
            margin: 30px 0 15px 0;
            color: #ffffff;
          }
          
          .blog-detail-content ul,
          .blog-detail-content ol {
            margin: 15px 0 15px 20px;
          }
          
          .blog-detail-content code {
            background: #f8f9fa;
            padding: 2px 6px;
            border-radius: 4px;
            font-family: 'Courier New', monospace;
            font-size: 14px;
            word-wrap: normal;
            overflow-wrap: normal;
            word-break: normal;
            hyphens: none;
          }
          
          .blog-detail-content pre {
            background: #f8f9fa;
            padding: 20px;
            border-radius: 8px;
            overflow-x: auto;
            margin: 20px 0;
            font-size: 14px;
            word-wrap: normal;
            overflow-wrap: normal;
            word-break: normal;
            hyphens: none;
          }
          
          /* Improve image responsiveness */
          .blog-detail-content img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 20px 0;
            border-radius: 8px;
            clear: both;
            float: none;
          }
          
          /* Better list styling for mobile */
          .blog-detail-content ul li,
          .blog-detail-content ol li {
            margin-bottom: 8px;
          }
          
          .blog-detail-actions {
            margin-top: 40px;
            padding-top: 30px;
            border-top: 1px solid #eee;
          }
          
          .blog-detail-back-btn {
            background-color: #6c757d;
            border: none;
            padding: 10px 25px;
            border-radius: 6px;
            font-weight: 600;
            color: white;
            text-decoration: none;
            transition: background-color 0.3s ease;
            display: inline-block;
          }
          
          .blog-detail-back-btn:hover {
            background-color: #5a6268;
            color: white;
          }
          
          /* Mobile-first responsive styles */
          @media (max-width: 768px) {
            .blog-detail-container {
              padding: 15px;
              margin: 0 10px;
            }
            
            .blog-detail-title {
              font-size: 28px;
              line-height: 1.3;
            }
            
            .blog-detail-content {
              font-size: 16px;
              line-height: 1.7;
            }
            
            .blog-detail-meta {
              font-size: 14px;
              gap: 10px;
            }
            
            .blog-detail-actions {
              margin-top: 30px;
              padding-top: 20px;
            }
            
            .blog-detail-back-btn {
              padding: 12px 20px;
              width: 100%;
              text-align: center;
            }
          }
          
          @media (max-width: 480px) {
            .blog-detail-container {
              padding: 10px;
              margin: 0 5px;
            }
            
            .blog-detail-title {
              font-size: 24px;
            }
            
            .blog-detail-content {
              font-size: 15px;
              line-height: 1.6;
            }
            
            .blog-detail-meta {
              font-size: 13px;
            }
          }
          
          /* Tablet styles */
          @media (min-width: 769px) and (max-width: 1024px) {
            .blog-detail-container {
              padding: 25px;
            }
            
            .blog-detail-title {
              font-size: 32px;
            }
            
            .blog-detail-content {
              font-size: 17px;
            }
          }
        `}
      </style>
      
      <div className="antialiased light-vz circle-v ">
        <Header events={events} />
        <br></br>
        <h1 className='spacer-section'></h1>

        {/* Blog Detail Section */}
        <section className="blog-detail-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="sec-title white-heading-text">
                  <span className="icon-inner wow flipInY" data-wow-duration="300ms">
                    <span className="fa-stack">
                      <i className="fa rhex fa-stack-2x"></i>
                      <i className="fa fa-newspaper-o fa-stack-1x"></i>
                    </span>
                  </span>
                  <h3 className="wow fadeInRight" data-wow-duration="500ms">
                    Blog Details
                    <small> / {blog.blogname}</small>
                  </h3>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="blog-detail-container">
                  <div className="blog-detail-meta">
                    <span className="blog-detail-author">By {blog.author}</span>
                    <span className="blog-detail-date">{formatDate(blog.date)}</span>
                    {blog.eventcode && (
                      <span className="blog-detail-event">Event: {blog.eventcode}</span>
                    )}
                  </div>
                  
                  <h1 className="blog-detail-title">{blog.blogname}</h1>
                  
                  <div className="blog-detail-content"  dangerouslySetInnerHTML={{ __html: blog.blogcontent }}>
                  </div>
                  
                  <div className="blog-detail-actions">
                    <a href="/blogs" className="btn blog-detail-back-btn">
                      ← Back to Blogs
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <MainWebFooter />
        <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
      </div>
    </>
  );
}

export default BlogDetail;